import { useEffect, useRef, useState } from 'react';
import mermaid from 'mermaid';
import { useKnowledgeBuilderColors } from '../../theme/knowledgeBuilderColors';

let initializedMode: 'dark' | 'light' | undefined;

export function ensureMermaidInitialized(mode: 'dark' | 'light') {
  if (initializedMode === mode) {
    return;
  }
  mermaid.initialize({
    startOnLoad: false,
    theme: mode === 'dark' ? 'dark' : 'default',
  });
  initializedMode = mode;
}

let diagramCounter = 0;

export function MermaidDiagram(props: { code: string }) {
  const colors = useKnowledgeBuilderColors();
  const [svg, setSvg] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  const idRef = useRef(`mermaid-diagram-${++diagramCounter}`);

  useEffect(() => {
    let cancelled = false;
    ensureMermaidInitialized(colors.mode);
    setSvg(null);
    setFailed(false);
    mermaid
      .render(idRef.current, props.code)
      .then(result => {
        if (!cancelled) {
          setSvg(result.svg);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setFailed(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [props.code, colors.mode]);

  if (failed) {
    return (
      <pre
        style={{
          margin: 0,
          padding: '11px 12px 13px',
          overflowX: 'auto',
          maxWidth: '100%',
          boxSizing: 'border-box',
          background: colors.code.bg,
          color: colors.code.text,
          fontSize: 12,
          lineHeight: 1.55,
          whiteSpace: 'pre',
        }}
      >
        {props.code}
      </pre>
    );
  }

  if (!svg) {
    return null;
  }

  return (
    <div
      style={{
        padding: 12,
        maxWidth: '100%',
        boxSizing: 'border-box',
        overflowX: 'auto',
        background: colors.code.bg,
      }}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
